// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSFollowProduct/index.less
// module id = 847
// module chunks = 42